<template>
  <span v-if="mobile" class="font-size-14px">
    {{ currentItinerary.segments[0].departure.iataCode }} -
    {{
      currentItinerary.segments[
        currentItinerary.segments.length - 1
      ].arrival.iataCode
    }}
  </span>
  <span v-else class="d-flex" style="gap: 8px">
    <span class="thin font-size-14px">
      Volo {{ currentSegmentIndex + 1 }} / {{ totalSegments }}:
    </span>
    <span
      v-if="segment"
      class="font-size-16px"
    >
      {{ airportName(segment.departure) }}
      -
      {{ airportName(segment.arrival) }}
    </span>
  </span>
</template>

<script>
export default {
  name: 'FlightSegmentDisplay',
  props: {
    mobile: {
      type: Boolean,
      default: false,
    },
    currentSegmentIndex: Number,
    totalSegments: Number,
    segment: Object,
    currentItinerary: Object,
    locations: Object,
  },
  methods: {
    /**
     * Resolve a display name for an endpoint. Falls back through the
     * provider's known-locations dictionary, the endpoint's own
     * `airportName`, then the raw IATA code so the header never crashes
     * when a code is missing from the dictionary.
     */
    airportName(endpoint) {
      if (!endpoint) return ''
      const { locations = {} } = this
      const { name: dict_name = '' } = locations[endpoint.iataCode] || {}
      if (dict_name) return dict_name
      return endpoint.airportName || endpoint.iataCode
    },
  },
}
</script>
